import { fetchApi } from "./fetchApi";

export default {
  async create({ name }) {
    const response = await fetchApi({
      data: {
        name,
      },
      method: "post",
      url: "/api/serviceAreaCategory/",
    });

    return response.data.result;
  },
  get(id) {
    return fetchApi({
      method: "get",
      url: `/api/serviceAreaCategory/${id}`,
    });
  },
  async list() {
    const response = await fetchApi({
      method: "get",
      url: "/api/serviceAreaCategory",
    });
    return response;
  },
  async update({ id, name }) {
    const response = await fetchApi({
      data: {
        name,
      },
      method: "put",
      url: `/api/serviceAreaCategory/${id}`,
    });

    return response.data.result;
  },
};
